// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userInformationStyles } from "@eisinc/Overrides/Widgets/AccountSettings/AccountSettingsUserInformation";
import { modalButtonsActionStyles } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

userInformationStyles.userInformationGridItem = {
    width: 12,
    css: css`
        & label {
            opacity: 1 !important;
            display: flex;
            justify-content: space-between;

            & button:focus,
            & a:focus {
                outline: 0 !important;
            }
        }
    `,
};

userInformationStyles.userInformationTitle = { variant: "h4" };

userInformationStyles.firstNameField = {
    cssOverrides: {
        formField: css`
            margin-bottom: 20px;
        `,
    },
};

userInformationStyles.userInformationWrapper = {
    css: css`
        width: 100%;
    `,
};

userInformationStyles.modalButtonsWrapper = {
    css: css`
        ${modalButtonsActionStyles.buttonsGridItem?.css}
        margin-top: 16px;
    `,
};
